<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<form
  #df="ngForm"
  novalidate
  (keydown.enter)="onSearch()"
  class="formborder"
>
  <div class="row m-0 align-items-center">
    <div class="col-md-2">
      <span class="required-lable"> To Date </span>

      <div class="datepicker_feild">
        <input
          [matDatepicker]="picker2"
          dateConvert
          placeholder="DD/MM/YYYY"
          name="ToDate"
          id="ToDate"
          #refToDate="ngModel"
          required
          class="form-control input-text-css"
          [(ngModel)]="ToDate"
          [ngClass]="{
            'is-invalid': df.submitted && refToDate.invalid,
            'alert-warning':
              refToDate.invalid &&
              (refToDate.dirty || refToDate.touched || refToDate.untouched)
          }"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </div>
    </div>

<div class="col-md-2">
    <span>Branch</span>
   <ng-multiselect-dropdown
    class="non-starter-multiselect"
    name="SelectBranch"
    id="SelectBranch"
    #refSelectBranch="ngModel"
    [(ngModel)]="SelectBranch"
    [placeholder]="'Select Branch'"
    [data]="BranchesList"
    [settings]="branchDropdownSettings"
    (onDropDownClose)="onBranchSelectionChange()"
  >
  </ng-multiselect-dropdown>
  <i class="fa-solid fa-angle-down dropdown-icon"></i>
</div>

<div class="col-md-2">
  <span>Product</span>
  <ng-multiselect-dropdown
    class="non-starter-multiselect"
    name="ProductId"
    id="ProductId"
    #refProductId="ngModel"
    [(ngModel)]="ProductId"
    [placeholder]="'Select Product'"
    [data]="ProductList"
    [settings]="productDropdownSettings"
    (onDropDownClose)="onProductSelectionChange()"
  >
  </ng-multiselect-dropdown>
  <i class="fa-solid fa-angle-down dropdown-icon"></i>
</div>

<div class="col-md-2">
  <span>Sales Executive</span>
  <ng-multiselect-dropdown
    class="non-starter-multiselect"
    name="SalesExecutiveId"
    id="SalesExecutiveId"
    #refSalesExecutiveId="ngModel"
    [(ngModel)]="SalesExecutiveId"
    [placeholder]="'Select Executive'"
    [data]="SalesExecutiveList"
    [settings]="SalesExecutiveDropdownSettings"
    (onDropDownClose)="onSalesExecutiveSelectionChange()"
  >
  </ng-multiselect-dropdown>
  <i class="fa-solid fa-angle-down dropdown-icon"></i>
</div>

     <div class="col-md-2">
      <span> No Of EMI </span>
      <input
        type="number"
        min="0"
        name="NoOfEmi"
        id="NoOfEmi"
        [(ngModel)]="NoOfEmi"
        placeholder="Enter EMI Count"
        class="form-control input-text-css"
      />
    </div>

    

    <div class="col-md-2 mb-2">
      <button
        type="button"
        (click)="onSearch()"
        class="mt-3 btn font-size-12 button-btn"
        [disabled]="!df.form.valid"
      >
        Search
      </button>
    </div>
    <div class="col-md-3 mt-3">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</form>
<div class="row mt-3" [hidden]="!DataSource">
  <div class="col-md-12">
    <div class="table-responsive">
      <mat-table
        class="table-bordered table-striped"
        matSort
        [dataSource]="DataSource"
        matTableExporter
        #exporter="matTableExporter"
        style="overflow: auto; height: 60vh; max-width: 100%"
      >
        <ng-container matColumnDef="#" style="max-width:0.625rem">
          <mat-header-cell mat-sort-header *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index">
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="LoanAcNo">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Loan No</mat-header-cell
          >
          <mat-cell *matCellDef="let row">{{ row.LoanAcNo }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Customer_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Customer Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Customer_Name }}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Customer_PhoneNo">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            Customer_PhoneNo
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
              <div *ngIf="currentUser.IsMaskingMobile">
                {{ row.Customer_PhoneNo | mask }}
              </div>

              <div *ngIf="!currentUser.IsMaskingMobile">
                {{ row.Customer_PhoneNo }}
              </div>
            </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Branch_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Branch Name</mat-header-cell
          >
          <mat-cell *matCellDef="let row">{{ row.Branch_Name }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Product_Name">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            Product Name
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.Product_Name }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Loan_Date">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >Loan Date</mat-header-cell
          >
          <mat-cell *matCellDef="let row">
            {{ row.Loan_Date | date:'dd/MM/yyyy'}}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Loan_Amount">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            Loan_Amount
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.Loan_Amount }}</mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Current_DueDate">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            Current DueDate
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.Current_DueDate | date:'dd/MM/yyyy'}}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
          ></mat-footer-cell>
        </ng-container>
        
        <ng-container matColumnDef="First_EMI_Date">
          <mat-header-cell mat-sort-header *matHeaderCellDef
            >First EMI Date</mat-header-cell
          >
          <mat-cell *matCellDef="let row" >
            {{ row.First_EMI_Date | date:'dd/MM/yyyy'}}
          </mat-cell>
          <mat-footer-cell *matFooterCellDef class="text-center"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="OverDue_Amount">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            OverDue_Amount
          </mat-header-cell>
          <mat-cell *matCellDef="let row"  class="text-center">{{
            row.OverDue_Amount
          }}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="text-center"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="DPD">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            DPD
          </mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.DPD }}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="text-center"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="EMI_Amount">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            EMI_Amount
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="text-center">{{
            row.EMI_Amount
          }}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="text-center"
          ></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="Mature_EMI">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            Mature_EMI
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="text-center">{{
            row.Mature_EMI
          }}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="text-center"
          ></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="InNACHPDC">
          <mat-header-cell mat-sort-header *matHeaderCellDef>
            InNACHPDC
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="text-center">{{
            row.InNACHPDC
          }}</mat-cell>
          <mat-footer-cell
            *matFooterCellDef
            class="text-center"
          ></mat-footer-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="sticky-footer fontcolor"
          style="background: var(--theme-primary)"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <mat-footer-row
          class="sticky-footer fontcolor"
          *matFooterRowDef="displayedColumns; sticky: true"
          style="background: var(--theme-primary)"
        ></mat-footer-row>
      </mat-table>
    </div>
    <div class="row m-0 ml-3" [hidden]="!DataSource">
      <div class="col-md-4 mt-2">
        <button
          class="mt-3 btn font-size-12 button-btn"
          (click)="exportExcel()"
        >
          <i
            class="fa fa-file-export mr-1"
            style="font-size: medium; cursor: pointer"
          ></i>
          Export
        </button>
      </div>
      <div class="col-md-8 mt-2">
        <mat-paginator
          #paginatorRef
          [pageSizeOptions]="[20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </div>
  </div>
</div>
<table
  id="loan-customer-deatils"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Ac No
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Customer Phone No
    </th>
    
     <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Branch Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Product Name
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Loan Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DueDate
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      First_EMI_Date
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      OverDue_Amount
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      DPD
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      EMI_Amount
    </th>
     <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Mature_EMI
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      InNACHPDC
    </th>
  </tr>
  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.LoanAcNo }}</td>
    <td>{{ x.Customer_Name  }}</td>
    <td>
      <div *ngIf="currentUser.IsMaskingMobile">
        {{ x.Customer_PhoneNo | mask }}
      </div>

      <div *ngIf="!currentUser.IsMaskingMobile">
        {{ x.Customer_PhoneNo }}
      </div>
    </td>
    <td>{{ x.Branch_Name }}</td>
    <td>{{ x.Product_Name }}</td>
    <td>{{ x.Loan_Date }}</td>
    <td>{{ x.Loan_Amount }}</td>
    <td>{{ x.Current_DueDate }}</td>
    <td>{{ x.First_EMI_Date }}</td>
    <td>{{ x.OverDue_Amount }}</td>
    <td>{{ x.DPD }}</td>
    <td>{{ x.EMI_Amount }}</td>
    <td>{{ x.Mature_EMI }}</td>
    <td>{{ x.InNACHPDC }}</td>
    </tr>
</table>
